/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Search } from 'semantic-ui-react';
// import { createClient } from '@google/maps';

import _ from 'lodash';

let debounced: any;
interface GeoSuggestProps {
  onChange?: any;
  placeholder?: string;
  onSuggestSelect?: any;
  location?: any;
  radius?: string;
}
export class GeoSuggest extends React.Component<GeoSuggestProps> {
  override componentWillMount() {
    this.resetComponent();
  }

  resetComponent = () => this.setState({ isLoading: false, results: [], value: '' });

  handleResultSelect = (e: any, data: any) => {
    const { result } = data;
    console.log('handleResultSelect', data);
    this.props.onChange(e, result);
    this.setState({ value: result.title });
  };

  handleSelectionChange = (e: any, data: any) => {
    console.log('handleSelectionChange', data);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  processSearch(value: any) {
    // const googleMapsClient = createClient({
    //   key: 'AIzaSyD8kWNqA5vkmLtKERwNMEoEr9ydgTmjBtA',
    //   rate: { limit: 1 },
    //   retryOptions: { interval: 5000 }
    // });
    // googleMapsClient.geocode(
    //   {
    //     address: value,
    //     bounds: {
    //       south: 47.167488,
    //       west: 11.093246,
    //       north: 51.370485,
    //       east: 23.088299
    //     }
    //   },
    //   (err: any, response: any) => {
    //     const rawResults = response.json.results;
    //     const results = rawResults.map(remapLocationSuggest);
    //     this.setState({ results, isLoading: false });
    //   }
    // );
  }

  handleSearchChange = (e: any, { value }: any) => {
    if (debounced) {
      debounced.cancel();
    }
    if (!value) {
      this.setState({ isLoading: false, value });
      return;
    }
    this.setState({ isLoading: true, value });
    debounced = _.debounce(() => this.processSearch(value), 500, { leading: true, trailing: false });
    debounced();
  };

  override render() {
    const { isLoading, value, results }: any = this.state;
    return (
      <Search
        fluid
        loading={isLoading}
        onResultSelect={this.handleResultSelect}
        onSearchChange={this.handleSearchChange}
        onSelectionChange={this.handleSelectionChange}
        results={results}
        value={value}
        {...this.props}
      />
    );
  }
}
